<template>
  {{ info }}
</template>

<script>
import { useCartStore } from '../pinia/CartStore'
import { mapState } from 'pinia'
import { productPrice } from '../helpers/product'

export default {
  props: {
    request: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState (useCartStore, [
      'cart',
      'itemCount',
      'totalPrice',
      'customsChargeLinePrice',
      'subtotalExcludingCustoms',
    ]),
    total () {
      return productPrice(this.totalPrice)
    },
    subtotalExclCustoms () {
      return productPrice(this.subtotalExcludingCustoms)
    },
    customsChargeTotal () {
      return productPrice(this.customsChargeLinePrice)
    },
    info () {
      return this.cart.loading ? this.default : this[this.request]
    }
  }
}
</script>
